export const FETCH_WASTE_PROVIDERS_REQUEST = 'FETCH_WASTE_PROVIDERS_REQUEST';
export const FETCH_WASTE_PROVIDERS_SUCCESS = 'FETCH_WASTE_PROVIDERS_SUCCESS';
export const FETCH_WASTE_PROVIDERS_FAILURE = 'FETCH_WASTE_PROVIDERS_FAILURE';

export const FETCH_WASTE_PROVIDER_REQUEST = 'FETCH_WASTE_PROVIDER_REQUEST';
export const FETCH_WASTE_PROVIDER_SUCCESS = 'FETCH_WASTE_PROVIDER_SUCCESS';
export const FETCH_WASTE_PROVIDER_FAILURE = 'FETCH_WASTE_PROVIDER_FAILURE';



// WEBPACK FOOTER //
// ./src/redux/constants/wasteProvider.js